(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieDialogController', PaieDialogController);

    PaieDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Paie'];

    function PaieDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Paie) {
        var vm = this;

        vm.paie = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paie.id !== null) {
                Paie.update(vm.paie, onSaveSuccess, onSaveError);
            } else {
                Paie.save(vm.paie, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:paieUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (result) {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.month = false;
        vm.datePickerOpenStatus.monthPrime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
